import { coSellMsftApi } from 'packages/tackle-api';
import { z } from 'zod';
import { reportError } from 'utils/monitor';

export const ListLocationsInputSchema = z.object({
  searchText: z.string().nullable().optional(),
});

export type ListLocationsInput = z.infer<typeof ListLocationsInputSchema>;

export const LocationOptionSchema = z.object({
  value: z.string(),
  display: z.string(),
  countryCode: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
  state: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  addressLine1: z.string().nullable().optional(),
  addressLine2: z.string().nullable().optional(),
  postalCode: z.string().nullable().optional(),
  label: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
});

export const LocationsSchema = z.array(
  LocationOptionSchema.partial().passthrough(),
);

export const ListLocationsResponseSchema = z.object({
  locations: LocationsSchema,
  count: z.number(),
});

export type ListLocationsResponse = z.infer<typeof ListLocationsResponseSchema>;
export type LocationOption = z.infer<typeof LocationOptionSchema>;

/**
 * Makes a GET request to the list locations endpoint.
 * @param  - searchQuery.
 * @returns A promise resolving to the response adhering to the `ListLocationsResponseSchema` schema.
 */
export async function listLocations({ searchQuery }: { searchQuery: string }) {
  const queryParams = new URLSearchParams({
    searchQuery,
  });

  try {
    const response = await coSellMsftApi
      .get(`api/locations?${queryParams?.toString()}`)
      .json();

    const parsedResponse = ListLocationsResponseSchema.parse(response);
    return parsedResponse;
  } catch (error) {
    reportError(error);
    throw error;
  }
}
